import styled from "@emotion/styled";
import { Box } from "@mui/material";
import { theme } from "../../theme";

export const BoxGoogleButton = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  margin: theme.spacing(2, 0),
}));
